import React, { useState } from "react";
import {
  Menu,
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useAvailability } from "../../hooks/useAvailability";

type UpdateSelectedActivitiesModalProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
  selectedCount: number;
  selectedOptions: string[];
};

export const UpdateSelectedActivitiesModal: React.FC<
  UpdateSelectedActivitiesModalProps
> = ({ anchorEl, open, handleClose, selectedCount, selectedOptions }) => {
  const [maxParticipants, setMaxParticipants] = useState("");
  const [cutOffTime, setCutOffTime] = useState("");
  const [blockStatus, setBlockStatus] = useState<boolean>(false);

  const { addAvailability } = useAvailability();

  const handleApply = async () => {
    const payload = {
      packageId: selectedOptions,
      maxParticipants: maxParticipants ? parseInt(maxParticipants) : undefined,
      cutOffTime: cutOffTime || undefined,
      blockDate: blockStatus || undefined,
    };

    try {
      const response = await addAvailability(payload);
      if (response) {
        console.log("Activities updated successfully:", response);
      } else {
        console.error("Failed to update activities.");
      }
    } catch (error) {
      console.error("Error updating activities:", error);
    }
    setMaxParticipants("");
    setCutOffTime("");
    setBlockStatus(false);
    handleClose();
  };

  return (
    <Menu
      id="update-selected-activities-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: 350,
          p: 2,
        },
      }}
    >
      {/* Title */}
      <Typography variant="body1" gutterBottom>
        Update ({selectedCount}) time slots
      </Typography>

      {/* Section 1: Block/Unblock */}
      <Box mb={2}>
        <Typography variant="subtitle1" gutterBottom>
          Block Time Slots
        </Typography>
        <Box display="flex" gap={1}>
          <Button
            variant={blockStatus === true ? "contained" : "outlined"}
            sx={{
              backgroundColor: blockStatus === true ? "#1E61DC" : undefined,
            }}
            fullWidth
            onClick={() => setBlockStatus(true)}
          >
            Block
          </Button>
          <Button
            variant={blockStatus === false ? "contained" : "outlined"}
            sx={{
              backgroundColor: blockStatus === false ? "#1E61DC" : undefined,
            }}
            fullWidth
            onClick={() => setBlockStatus(false)}
          >
            Unblock
          </Button>
        </Box>
      </Box>

      {/* Section 2: Max Participants */}
      <Box mb={2}>
        <Typography variant="subtitle1" gutterBottom>
          Update Max Participants
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="Enter number"
          value={maxParticipants}
          onChange={(e) => setMaxParticipants(e.target.value)}
        />
      </Box>

      {/* Section 3: Cutoff Time */}
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Update Cutoff Time
        </Typography>
        <FormControl fullWidth size="small">
          <InputLabel id="cutoff-time-label">Cutoff Time</InputLabel>
          <Select
            labelId="cutoff-time-label"
            value={cutOffTime}
            label="Cutoff Time"
            onChange={(e) => setCutOffTime(e.target.value)}
          >
            <MenuItem value="15m">15 minutes</MenuItem>
            <MenuItem value="30m">30 minutes</MenuItem>
            <MenuItem value="1h">1 hour</MenuItem>
            <MenuItem value="2h">2 hours</MenuItem>
          </Select>
        </FormControl>
        {/* Apply Button */}
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#1E61DC" }}
            onClick={handleApply}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </Menu>
  );
};
